import React, { useEffect, useContext } from 'react'
import "../css/copyright.css"
import { motion, useAnimation } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import { ScrollContext } from '../helpers/ScrollContext'
import { TermsContext } from '../helpers/TermsContext'
import { PrivacyContext } from '../helpers/PrivacyContext'

const Copyright = ({ showNav }) => {

const { scroller, setScroller } = useContext(ScrollContext)
const { terms, showTerms } = useContext(TermsContext)
const { privacy, showPrivacy } = useContext(PrivacyContext)

const combinedTerms = () => {
  showTerms(true)
  setScroller(true)
}

const combinedPrivacy = () => {
  showPrivacy(true)
  setScroller(true)
}


const d = new Date();
let year = d.getFullYear();

const [ ref2, inView2 ] = useInView()

const cookieIn = useAnimation()
const privacyIn = useAnimation()
const termsIn = useAnimation()
const copyrightIn = useAnimation()
const mantaIn = useAnimation()

useEffect(() => {
  if(inView2){
      privacyIn.start({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.9, 0.5, 0, 0.8], delay: 0.4 } })
      termsIn.start({  opacity: 1, y: 0, transition: {duration: 0.7, ease: [0.9, 0.5, 0, 0.8], delay: 0.55 } })
      copyrightIn.start({  opacity: 1, y: 0, transition: {duration: 0.7, ease: [0.9, 0.5, 0, 0.8], delay: 0.7 } })
      mantaIn.start({  opacity: 1, y: 0, transition: {duration: 0.7, ease: [0.9, 0.5, 0, 0.8], delay: 0.95 } })

  }
  if(!inView2){
      privacyIn.start({ opacity: 0, y: 40, transition: { duration: 0 } })
      termsIn.start({ opacity: 0, y: 40, transition: { duration: 0 } })
      copyrightIn.start({ opacity: 0, y: 40, transition: { duration: 0 } })
      mantaIn.start({ opacity: 0, y: 40, transition: { duration: 0 } })
  }
}, [inView2])



  return (
    <>
    <div ref={ref2} className="copyright">
      <div></div>
      <motion.div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', 
                        filter: "blur(0.5px)",
                        WebkitTransform: "translateZ(0)",
                        transform: "translateZ(0)",
                        WebkitBackfaceVisibility: "hidden",
                        backfaceVisibility: "hidden",
                        willChange: "filter"  }}>
        <div>
          <div style={{ overflow: 'hidden' }}><motion.div onClick={() => combinedPrivacy()} style={{cursor: "pointer", marginRight: 10}} animate={ privacyIn } whileHover={{ color: "#ddd", transition: { duration: 0.5 } }}>PRIVACY POLICY</motion.div></div>
          <div style={{ overflow: 'hidden' }}><motion.div style={{ cursor: "pointer" }} animate={ termsIn } onClick={() => combinedTerms()} whileHover={{ color: "#ddd", transition: { duration: 0.5 } }}>TERMS & CONDITIONS</motion.div></div>
        </div>
        <motion.div className="copy2">
            <div style={{ overflow: 'hidden' }}><motion.div animate={ copyrightIn }>&copy; GALANTIS { year }</motion.div></div>
            <div style={{ overflow: 'hidden' }}><motion.div animate={ mantaIn }>WEBSITE BY <motion.a style={{ textDecoration: "none" }} whileHover={{ letterSpacing: "0.2em", color: "#ddd" }} transition={{ duration: 0.5 }} className='li1' href='https://manta.studio' target="_blank"><strong>MANTA</strong></motion.a></motion.div></div>
        </motion.div>
      </motion.div>
      <div></div>
    </div>
    </>
  )
}

export default Copyright